/**
 * 操作者のStateを扱うモジュール
 */
import { ActionsUnion, createAction } from 'common/utils/action-utils';

enum ActionTypes {
  LOGGED_IN = 'app/principal/LOGGED_IN',
  LOGGED_OUT = 'app/principal/LOGGED_OUT',
  RE_LOGIN = 'app/principal/RE_LOGIN'
}

/**
 * ログインのActionを作成する
 */
export const loggedIn = (): { type: ActionTypes } =>
  createAction(ActionTypes.LOGGED_IN);

/**
 * ログアウトのActionを作成する
 */
export const loggedOut = (): { type: ActionTypes } =>
  createAction(ActionTypes.LOGGED_OUT);

/**
 * 再ログインのActionを作成する
 */
export const reLogin = (): { type: ActionTypes } =>
  createAction(ActionTypes.RE_LOGIN);

const actions = {
  loggedIn,
  loggedOut,
  reLogin
};
type PrincipalAction = ActionsUnion<typeof actions>;

/**
 * PrincipalのState
 */
export interface Principal {
  /** ログインしているか否か */
  isLoggedIn: boolean;
  /** 再ログイン予定か否か */
  isReLogin: boolean;
}

const initialState: Principal = {
  isLoggedIn: false,
  isReLogin: false
};

export default (
  state: Principal = initialState,
  actions: PrincipalAction
): Principal => {
  switch (actions.type) {
    case ActionTypes.LOGGED_IN:
      return {
        ...state,
        isLoggedIn: true
      };
    case ActionTypes.LOGGED_OUT:
      return {
        ...state,
        isLoggedIn: false
      };
    case ActionTypes.RE_LOGIN:
      return {
        ...state,
        isReLogin: true
      };
    default:
      return state;
  }
};
